import { Button, Image } from "@chakra-ui/react";
import { logEvent } from "firebase/analytics";
import { collection, onSnapshot } from "firebase/firestore";
import { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import { analytics, firestore } from "../firebase";
import { useAtom } from "jotai";
import { windowSizeState } from "../jotai";
import { MemberInfo } from "../types/typeDefs";
import logo from "./../Home/nz country.png";
import hunters from "./Hunters_2.14.1.jpg";
import sight from "./Sight_cropped.jpg";
import redDeer from "./videoCover.png";

// const Speaker = () => {
//   return <Icon as={AiFillSound} color={"#EA9101"} />;
// };

export const About = () => {
  const nav = useNavigate();

  useEffect(() => {
    logEvent(analytics, "page_view", { page_title: "About" });
  }, []);

  const [teamMembers, setTeamMembers] = useState<Array<MemberInfo>>([]);
  const [ended, setEnded] = useState(false);
  const [replay, setReplay] = useState(false);
  const [autoplay, setAutoplay] = useState(0);

  const containerRef = useRef<HTMLDivElement | null>(null);
  const playerRef = useRef<any>(null);

  useEffect(() => {
    const unsub = onSnapshot(collection(firestore, `team`), (snapshot) => {
      setTeamMembers([]);
      snapshot.forEach((snapDoc) => {
        setTeamMembers((prev) => {
          return [...prev, { ...snapDoc.data(), id: snapDoc.id } as MemberInfo];
        });
      });
    });
    return unsub;
  }, []);

  const [size] = useAtom(windowSizeState);

  const schema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "NZ COUNTRY",
    url: "https://www.nzcountry.guide",
    logo: "https://firebasestorage.googleapis.com/v0/b/nzcountry.appspot.com/o/partners%2FNZCOUNTRY.jpg?alt=media",
    contactPoint: {
      "@type": "ContactPoint",
      email: "mailto:mark@nzcountry.guide",
      contactType: "customer service",
    },
    video: {
      "@type": "VideoObject",
      name: "See a short video of NZ COUNTRY in 2024 out on a guided hunt for red deer and tahr in New Zealand.",
      description:
        "A short video introducing a NZ COUNTRY guided hunt. In this video our professional hunting guides take some clients in to the wild to find some red deer and tahr in New Zealand.",
      thumbnailUrl:
        "https://firebasestorage.googleapis.com/v0/b/nzcountry.appspot.com/o/teamImages%2Fethan_2.73.1.jpg?alt=media",
      uploadDate: "2024-06-26",
      contentUrl: "https://youtu.be/TcY-hQwJL_o?si=JlpKByYpkaRyVtc1",
      embedUrl: "https://www.youtube.com/embed/TcY-hQwJL_o?si=JlpKByYpkaRyVtc1",
      duration: "5:49",
      publisher: {
        "@type": "Organization",
        name: "SCRYPTWORX STUDIOS",
        logo: {
          "@type": "ImageObject",
          url: "https://firebasestorage.googleapis.com/v0/b/nzcountry.appspot.com/o/partners%2FSWS.jpg?alt=media",
        },
      },
    },
  };

  useEffect(() => {
    // Load the IFrame API only once
    if (!(window as any).YT) {
      const tag = document.createElement("script");
      tag.src = "https://www.youtube.com/iframe_api";
      document.body.appendChild(tag);
    }

    const initPlayer = () => {
      if (!containerRef.current) return;

      playerRef.current = new (window as any).YT.Player(containerRef.current, {
        videoId: "TcY-hQwJL_o", // replace with your own video ID
        playerVars: { autoplay: autoplay, modestbranding: 1 },
        events: {
          onStateChange: (event: any) => {
            if (event.data === (window as any).YT.PlayerState.ENDED) {
              console.log("Video ended!");
              if (playerRef.current) {
                playerRef.current.destroy();
                playerRef.current = null;
              }
              setEnded(true);
            }
          },
        },
      });
    };

    // If API is already loaded
    if ((window as any).YT && (window as any).YT.Player) {
      initPlayer();
    } else {
      (window as any).onYouTubeIframeAPIReady = initPlayer;
    }

    return () => {
      //Cleanup: destroy the player safely
      if (playerRef.current) {
        playerRef.current.destroy();
        playerRef.current = null;
      }
    };
  }, [replay]);

  //   useEffect(() => {
  //   const initPlayer = () => {
  //     if (!containerRef.current) return;

  //     playerRef.current = new (window as any).YT.Player(containerRef.current, {
  //       videoId: "TcY-hQwJL_o",
  //       events: {
  //         onStateChange: (event: any) => {
  //           if (event.data === (window as any).YT.PlayerState.ENDED) {
  //             setEnded(true);
  //           }
  //         },
  //       },
  //     });
  //   };

  //   if ((window as any).YT && (window as any).YT.Player) {
  //     initPlayer();
  //   } else {
  //     (window as any).onYouTubeIframeAPIReady = initPlayer;
  //   }

  //   return () => {
  //     if (playerRef.current) {
  //       playerRef.current.destroy();
  //     }
  //   };
  // }, []);

  const handleReplay = () => {
    setAutoplay(1);
    setReplay(!replay);
    setEnded(false);

    // if (playerRef.current) {
    //   playerRef.current.seekTo(0);  // rewind to start
    //   playerRef.current.playVideo(); // start playing
    //   setEnded(false);
    // }
  };

  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      </Helmet>
      <div
        style={{
          height: "100vh",
          overflowY: "hidden",
          backgroundColor: "rgba(0,0,0,.9)",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            paddingTop: `${size.height / 20}px`,
            //paddingBottom: `${height / 20}px`,
            //overflowY: "scroll",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              height: `${(size.height / 28) * 3}px`,
              width: "95%",
              maxWidth: "1200px",

              color: "#EA9101",
              fontFamily: "anton",
              fontSize: size.width < 550 ? "30px" : `${size.width / 30}px`,
              borderRadius: "3px",
            }}
          >
            <h1
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                height: "100%",
                color: "#EA9101",
              }}
            >
              ABOUT
            </h1>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              width: "90%",
              maxWidth: "400px",
              minHeight: "40px",
              justifyContent: "space-between",
            }}
          >
            <Button
              variant="link"
              size="lg"
              color={"#B0B0A0"}
              onClick={() => nav("/")}
              fontFamily={"anton"}
              letterSpacing={1.5}
            >
              Home
            </Button>
            <Button
              variant="link"
              size="lg"
              color={"#B0B0A0"}
              onClick={() => nav("/trophy-hunting-new-zealand")}
              fontFamily={"anton"}
              letterSpacing={1.5}
            >
              Trophy Hunts
            </Button>
            <Button
              variant="link"
              size="lg"
              color={"#B0B0A0"}
              onClick={() => {
                logEvent(analytics, "select_item", {
                  item_list_name: "about to team",
                });
                nav("/professional-hunting-guide-team");
              }}
              fontFamily={"anton"}
              letterSpacing={1.5}
            >
              The Team
            </Button>
            {/* {isSound ? (
            <IconButton
              variant={"link"}
              icon={<Speaker />}
              aria-label="Stop"
              onClick={() => {
                setIsSound(false);
                sound.current.pause();
              }}
            />
          ) : (
            <IconButton
              variant={"link"}
              icon={<Speaker />}
              aria-label="Play"
              onClick={() => {
                setIsSound(true);
                sound.current.play();
              }}
            />
          )} */}
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              height: `${(size.height / 20) * 16}px`,
              //backgroundColor: "whitesmoke",
              // backgroundImage: `url(${stag})`,
              backgroundPosition: "center",
              //objectPosition: "center",
              width: "95%",
              maxWidth: "1200px",
              //padding: "2rem",
              overflowY: "scroll",
              borderRadius: "3px",
              fontSize: size.width < 700 ? ".9rem" : "1.3rem",
              textAlign: "justify",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                paddingTop: "1rem",
                //backgroundColor: "rgba(255,255,255,.7)",
                color: "#B0B0A0",
                width: "100%",
              }}
            >
              {" "}
              <div
                style={{
                  width: "80%",
                  paddingTop: "5rem",
                  paddingBottom: "2rem",
                  display: "flex",
                  flexDirection: size.width > 1000 ? "row" : "column",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    paddingRight: size.width > 1000 ? "5rem" : "0rem",
                  }}
                >
                  NZ COUNTRY is your premier destination for world-class hunting
                  adventures on the breathtaking West Coast of New Zealand. Our
                  company prides itself on offering unforgettable experiences,
                  combining the thrill of the hunt with the comfort of luxury
                  accommodations. Nestled in the dense native bush, our two
                  secluded 5-star hunting lodges provide the perfect retreat for
                  discerning hunters seeking both adventure and relaxation.
                </div>
                <div
                  style={{
                    paddingTop: "2rem",
                    backgroundImage: `url(${hunters})`,
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                    objectFit: "contain",
                    color: "#EA9101",
                    width: "100%",
                    height: "100%",
                    minHeight: "200px",
                    textAlign: "center",
                    borderRadius: ".5rem",
                  }}
                ></div>
              </div>
              <div
                style={{
                  width: "80%",
                  paddingTop: "5rem",
                  paddingBottom: "5rem",
                  fontStyle: "italic",
                  fontWeight: "bold",
                  color: "#EA9101",
                  textAlign: "center",
                }}
              >
                At NZ COUNTRY, we specialize in hunting trips for Trophy Red
                Deer Stags, Thar, Chamois, Fallow Deer, Awapara Rams, and Trophy
                Goats.
              </div>
              {/* <YouTube
                videoId="TcY-hQwJL_o?si=o3mlJTSawTY0Xity"
                opts={{
                  height:
                    width < 650 ? (width / 19) * 9 : ((width * 0.51) / 16) * 9,
                  width: width < 650 ? width : width * 0.51,
                  origin: "http://localhost:3000",
                }}
                onEnd={(e: any) => {
                  console.log(e);
                }}
                onStateChange={(e: any) => console.log("Change")}
                onPlay={(e: any) => console.log("Play")}
              /> */}
              {/* <iframe
              //ref={vidRef}
              width={width < 650 ? width : width * 0.51}
              height={
                width < 650 ? (width / 19) * 9 : ((width * 0.51) / 16) * 9
              }
              src="https://www.youtube.com/embed/TcY-hQwJL_o?si=o3mlJTSawTY0Xity?rel=0"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            ></iframe> */}
              {!ended ? (
                <div ref={containerRef}></div>
              ) : (
                <img
                  src={redDeer}
                  alt="Video ended"
                  style={{ width: "90%", maxWidth: "600px", cursor: "pointer" }}
                  onClick={handleReplay}
                />
              )}
              {/* <img src={redDeer} alt="Video ended" style={{visibility: ended ? "visible" : "hidden"}} /> */}
              {/* <div ref={containerRef}  /> */}
              {ended && (
                <div className="absolute inset-0 flex items-center justify-center bg-black/60">
                  <button
                    onClick={handleReplay}
                    className="px-4 py-2 bg-white rounded shadow"
                  >
                    ▶ Play Again
                  </button>
                </div>
              )}
              <div
                style={{
                  width: "80%",
                  paddingTop: "8rem",
                  //paddingBottom: "5rem",
                  fontStyle: "italic",
                  fontWeight: "bold",
                  color: "#EA9101",
                  textAlign: "center",
                }}
              >
                Our Professional Hunting Guides
              </div>
              <div
                style={{
                  width: "80%",
                  display: "flex",
                  flexDirection: size.width < 750 ? "column" : "row",
                  alignItems: "center",
                  justifyContent: "space-evenly",
                  paddingTop: "5rem",
                  paddingBottom: "2rem",
                }}
              >
                {teamMembers &&
                  teamMembers.map((member, idx) => {
                    return (
                      <Image
                        key={idx}
                        //width={(width * 0.8) / 6}
                        boxSize={
                          size.width < 750 ? 200 : (size.width * 0.8) / 8
                        }
                        src={member.squareImage}
                        onClick={() => {
                          logEvent(analytics, "select_item", {
                            item_list_name: member.name,
                          });
                          nav("/team");
                        }}
                        style={{ cursor: "pointer" }}
                      />
                    );
                  })}
              </div>
              <div
                style={{
                  width: "80%",

                  paddingBottom: "2rem",
                }}
              >
                On a hunt, you will be assisted by our expert guides who have
                years of experience with firearms and hunting alike. With half
                of the team being military veterans, we take pride in our
                military grade shooting coaching and bushcraft skills. Our
                guides will lead you on exhilarating hunts through some of the
                most challenging and scenic terrains in New Zealand. Whether you
                are stalking through the lush undergrowth or navigating rugged
                mountain passes, each hunt promises excitement, challenge, and
                the opportunity to take home a coveted trophy.
              </div>
              <Button
                variant="outline"
                onClick={() => nav("/team")}
                color={"#EA9101"}
                borderColor={"#EA9101"}
              >
                Learn more about our guides
              </Button>
              <div
                style={{
                  width: "80%",
                  paddingTop: "5rem",
                  paddingBottom: "2rem",
                  display: "flex",
                  flexDirection: size.width > 1000 ? "row" : "column",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    paddingTop: "2rem",
                    backgroundImage: `url(https://firebasestorage.googleapis.com/v0/b/nzcountry.appspot.com/o/images%2FCarry%20Out_2.21.1.jpg?alt=media)`,
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                    objectFit: "contain",
                    color: "#EA9101",
                    width: "100%",
                    height: "100%",
                    minHeight: "200px",
                    textAlign: "center",
                    borderRadius: ".5rem",
                  }}
                ></div>
                <div
                  style={{
                    width: size.width > 1000 ? "80%" : "100%",
                    // paddingTop: "5rem",
                    // paddingBottom: "5rem",
                    paddingLeft: size.width > 1000 ? "5rem" : "0rem",
                  }}
                >
                  In addition to our exceptional hunting opportunities, we offer
                  a range of premium services to enhance your adventure.
                  Experience the thrill of a helicopter ride over the stunning
                  landscapes of the West Coast, providing access to remote
                  hunting grounds and breathtaking aerial views. For those
                  looking to improve their marksmanship, our long-range shooting
                  and range work sessions are led by skilled instructors who
                  will help you perfect your technique. And for those who wish
                  to capture the beauty of their journey, our photography
                  services ensure that every moment is immortalized in stunning
                  detail.
                </div>
              </div>
              <div
                style={{
                  width: "80%",
                  paddingTop: "5rem",
                  paddingBottom: "2rem",
                  fontStyle: "italic",
                  fontWeight: "bold",
                  color: "#EA9101",
                  textAlign: "center",
                }}
              >
                At NZ COUNTRY, we also partner with some of the best in the
                business.
              </div>
              <div
                style={{
                  width: "80%",
                  display: "flex",
                  flexDirection: size.width < 750 ? "column" : "row",
                  alignItems: "center",
                  justifyContent: "space-evenly",
                  paddingTop: "1rem",
                  paddingBottom: "8rem",
                }}
              >
                <Image
                  //width={(width * 0.8) / 6}
                  boxSize={size.width < 750 ? 200 : (size.width * 0.8) / 8}
                  src={
                    "https://firebasestorage.googleapis.com/v0/b/nzcountry.appspot.com/o/partners%2FNZAMMO.jpg?alt=media"
                  }
                  onClick={() => window.open("https://www.nzammo.co.nz/")}
                  style={{ cursor: "pointer" }}
                />
                <Image
                  boxSize={size.width < 750 ? 200 : (size.width * 0.8) / 8}
                  src={
                    "https://firebasestorage.googleapis.com/v0/b/nzcountry.appspot.com/o/partners%2FPROOF.jpg?alt=media"
                  }
                  onClick={() => window.open("https://proofresearch.com/")}
                  style={{ cursor: "pointer" }}
                />
                <Image
                  boxSize={size.width < 750 ? 200 : (size.width * 0.8) / 8}
                  src={
                    "https://firebasestorage.googleapis.com/v0/b/nzcountry.appspot.com/o/partners%2FTYRON.jpg?alt=media"
                  }
                  onClick={() =>
                    window.open("https://tyronsouthwardtaxidermy.co.nz/")
                  }
                  style={{ cursor: "pointer" }}
                />
                <Image
                  boxSize={size.width < 750 ? 200 : (size.width * 0.8) / 8}
                  src={
                    "https://firebasestorage.googleapis.com/v0/b/nzcountry.appspot.com/o/partners%2FSWS.jpg?alt=media"
                  }
                  onClick={() => window.open("https://scryptworxstudios.com/")}
                  style={{ cursor: "pointer" }}
                />
                <Image
                  boxSize={size.width < 750 ? 200 : (size.width * 0.8) / 8}
                  src={
                    "https://firebasestorage.googleapis.com/v0/b/nzcountry.appspot.com/o/partners%2FNZPHGA.jpg?alt=media&"
                  }
                  onClick={() => window.open("https://www.nzphga.com/")}
                  style={{ cursor: "pointer" }}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  paddingTop: "2rem",
                  backgroundImage: `url(${sight})`,
                  backgroundPosition: "center",
                  backgroundSize: "cover",
                  objectFit: "contain",
                  color: "#EA9101",
                  width: "100%",
                  height: "30vh",
                  textAlign: "center",
                }}
              >
                <div>
                  <Image
                    src={logo}
                    //width={width / 6}
                    style={{
                      width: size.width < 700 ? "250px" : `${size.width / 7}px`,
                      maxWidth: "150px",
                    }}
                    loading="eager"
                    onClick={() => nav("/inquire")}
                  />
                </div>
                <Button
                  variant="outline"
                  onClick={() => nav("/inquire")}
                  color={"#EA9101"}
                  borderColor={"#EA9101"}
                >
                  Come hunt with us - Inquire
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
